import { Component, OnInit } from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MessageService} from 'primeng/api';
import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-inteli-search',
  templateUrl:'./inteli-search.component.html',
  styleUrls: ['./inteli-search.component.css'],
  providers: [MessageService]
})
export class InteliSearchComponent implements OnInit {
  items: any[];
  departments: any[];
  towns: any[];
  zones: any[];
  services: any[];
  specialties = [];
  specialtiesCache = [];
  telemedicine: boolean;
  countryTitle: string;
  departmentTitle: string;
  loginBtnTitle: string;
  townTitle: string;
  zoneTitle: string;
  cardTitle: string;
  serviceTitle: string;
  specialtyTitle: string;
  userform: FormGroup;
  selectedCity = -1;
  selectedTown = -1;
  selectedDepartment = -1;
  selectedZone = -1;
  submitted: boolean;
  resultProviders = [];
  env = environment;
  constructor(private realm: RealmService, private Rc: FirebaseService, private fb: FormBuilder,
              private messageService: MessageService, private router: Router, ) {
    
    this.realm.getServicesOrm();
    this.realm.services$.subscribe((data: any) => {
      this.services = data;
    });
  }
  ngOnInit(): void {
    this.telemedicine = false;
    
    this.realm.getCountriesWorld();
    this.Rc.fetchActivate().then(() => {
      this.countryTitle = this.Rc.getStringRC('global_select_country_title');
      this.departmentTitle = this.Rc.getStringRC('global_select_country_title');
      this.townTitle = this.Rc.getStringRC('global_select_country_title');
      this.zoneTitle = this.Rc.getStringRC('global_select_country_title');
      this.cardTitle = this.Rc.getStringRC('global_select_country_title');
      this.loginBtnTitle = 'Buscar';
    });
    this.userform = this.fb.group({
      town: new FormControl(''),
      zone: new FormControl(''),
      department: new FormControl(''),
      country: new FormControl(''),
      name: new FormControl(''),
      services: new FormControl(''),
      specialties: new FormControl(''),
    });
    this.userform.get('country').statusChanges.subscribe( data => {
      this.selectedCity = this.userform.get('country').value.codigo;
      this.realm.getDepartmentsWorld(this.selectedCity);
    });
    this.userform.get('department').statusChanges.subscribe( data => {
      this.selectedDepartment = this.userform.get('department').value.id;
      this.realm.getTownsWorld(this.selectedDepartment);
    });
    /*this.userform.get('town').statusChanges.subscribe( data => {
      this.selectedTown = this.userform.get('town').value.id;
      this.zones = this.userform.get('town').value.zone;
    });
    this.userform.get('zone').statusChanges.subscribe( data => {
      this.selectedZone = this.userform.get('zone').value.id;
    });*/
    this.userform.get('services').statusChanges.subscribe( datas => {
      const code = this.userform.get('services').value.code.toString();
      console.log('specialtyList:::', code);
      if ( code === '1') {
        if (this.specialtiesCache?.length > 0) {
          console.log('specialtyList:::', this.specialtiesCache);
          this.specialties = this.specialtiesCache;
        } else {
          console.log('specialtyList:::', 'getspecialtylist');
          this.realm.getSpecialtyList();
          this.realm.specialtyListQuery$.subscribe(async (data: any) => {
            //await this.parseSpecialty(data);
            this.specialtiesCache = data;
            this.specialties = this.specialtiesCache;
            console.log('specialtyList:::', data);
          });
        }
      } else {
        this.specialties = [];
      }
    });
    this.realm.countries$.subscribe((data: any) => {
      this.items = data;
    });
    this.realm.departments$.subscribe((data: any) => {
      this.departments = data;
    });
    this.realm.towns$.subscribe((data: any) => {
      this.towns = data;
    });
  }
  onSubmit(value: string) {
    this.submitted = true;
    this.messageService.add({severity: 'info', summary: 'Success', detail: 'Form Submitted', sticky: false});
    const d = JSON.parse(JSON.stringify(value));
    const data = {
      ct: d.country.codigo,
      tp: d.services.code,
      dp: d.department.depName,
      tn: d.town.munName,
      sp: d.specialties.strDescription,
      nm: d.name,
      tm: this.telemedicine
    };
    if (data.ct === undefined) {
      data.ct = '';
    }
    if (data.tp === undefined) {
      data.tp = '';
    }
    if (data.dp === undefined) {
      data.dp = '';
    }
    if (data.tn === undefined) {
      data.tn = '';
    }
    if (data.sp === undefined) {
      data.sp = '';
    }
    if (data.nm === undefined) {
      data.nm = '';
    }
    console.log('values of submit', JSON.stringify(d));
    // tslint:disable-next-line:max-line-length
    this.router.navigate(['home/providersearch', 'resultados', 'inteli-search', data.ct, data.tp, data.dp, data.tn, data.sp, data.nm, data.tm]);
    // this.router.navigate('/providersearch', {type: 'resultados', ct: d.country.codigo, dt: d.services.code, tm: d.town.munName, sp: d.specialties.strDescription, ne: d.name });
    // tslint:disable-next-line:max-line-length
    /*this.realm.getProvidersByType(d.country.codigo, d.services.code, d.department.depName, d.town.munName, d.specialties.strDescription, d.name).then( value1 => {
      this.realm.providersByTypeQuery$.subscribe(data => {
        if (JSON.stringify(data).length >= 5) {
          this.router.navigate(['/providersearch', 'resultados']);
        }
      });
    });*/
  }
  async findProviders(data: any) {
    for (const dataKey in data) {
      if (data.hasOwnProperty(dataKey)) {
        this.specialtiesCache.push({strDescription: data[dataKey][0].strDescription, alias: data[dataKey][0].alias, data: data[dataKey]});
        this.specialties = this.specialtiesCache;
      }
    }
  }
  async parseSpecialty(data: any) {
    for (const dataKey in data) {
      if (data.hasOwnProperty(dataKey)) {
        //this.specialtiesCache.push({strDescription: data[dataKey][0].strDescription, alias: data[dataKey][0].alias, data: data[dataKey]});
        this.specialties = this.specialtiesCache;
      }
    }
  }
}
